import { appendFirstBlocks } from './utils/appendFirstBlocks';
import { appendSecondBlocks } from './utils/appendSecondBlocks';
import { getMatrixFromXLSX } from './utils/getMatrixFromXLSX';
import { matrixToBlocks } from './utils/matrixToBlocks';

export function hgParseMicromeritics(blob) {
  let result = {};
  const matrix = getMatrixFromXLSX(blob);
  const parsed = matrixToBlocks(matrix);
  // blocks 0 contains meta information
  appendFirstBlocks(parsed[0], result);
  // blocks 1 contains data
  appendSecondBlocks(parsed[1], result);

  return result;
}
